import React from 'react';
import {_GPY,__GPYPost , __GPYGet} from '../../env.js'
import $ from "jquery";


class OBSOLATE_GameScoreBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        NAME: "SoccerFootball",
        defaultValuesLoaded : false,
        components : {},
        currentGame: {id:-1},
        gamesIsLoaded: false,
        games : {},
        selectedPlayers : {},

        advertisementsIsLoaded : false,
        advertisements : {},

        overlayConfig : {},
        overlayConfigIsLoaded: false,

        tournamentsIsLoaded: false,
        tournaments: {},

        dataStore  : {},
        defaultDataStore:{},

        displayWidth : 480,

        currentLayout: {id:-1},
        layoutsIsLoaded : false,
        layouts : {},
    };
  }

  registerButton(name,c) {
  }
  
  getTournaments(obj) {
        if(obj === undefined) {
          obj = {};
        }
        __GPYPost('getTournaments',obj,(res) => {

           res.Tournaments.Tournament.map((t) => {
               t._data = JSON.parse(t.data);
           });

           this.setState({
            tournamentsIsLoaded: true,
            tournaments: res,
           });
        },(err)=>{
        });
    }

    fillTournamentData(tournament,games) {
      var g = this.getGameMapByTournament(tournament,games);
      console.log("GAMES",g);
      var res = {};
      tournament._data.games.map((p,i)=>{
          p.map((v,c)=>{
              if(v>0) {
                  res[ i+"-"+c ] = g[v];
                  delete res[ i+"-"+c ].crews;
                  delete res[ i+"-"+c ].players;
                  delete res[ i+"-"+c ].referees;
              } else {
                   res[ i+"-"+c ] = {id:-1};
              }
                console.log("REPLACE",v);
          });
      });

      return res;
    }

    getGameMapByTournament(tournament,games) {
        var seen = [];
        tournament._data.games.map((p)=>{
    //      console.log("p:",p);
          p.map((v)=>{
      //      console.log("CHECK:",v);
              if (!seen.includes(v)) {
                seen.push(v);
              }
          });
        });
        var res = {};
        games.map((g)=>{
          if( seen.includes(g.id) ) {
            res[g.id] = g;
          }
        });
        return res;
    }

  storeData(){
			var json = JSON.stringify(this.state.dataStore);
			__GPYPost("storeGameData",{gameId:this.state.currentGame.id,dataKey:"DATA_STORE",dataValue:json});
	}


  getGPYState(name) {
    console.log("__STATE",this.state);
    this.state.NAME = name;

    return this.state;
  }

  setGameType(f){
     this.props.setGameType(f);
  }


  /* ===========================================================================
  *  Layouts
  */
  getLayouts(){
    __GPYGet('getLayouts',(res)=>{
      this.setState({
        layoutsIsLoaded: true,
        layouts: res.Layouts.Layout,
        currentLayout: {id:-1},
      });
      if(_GPY.uiStates.currentOverlayLayout !== undefined) {
        this.setCurrentLayout( parseInt(_GPY.uiStates.currentOverlayLayout));
      }
    },(err)=>{
      this.setState({
        layoutsIsLoaded: false,
        currentLayout: {id:-1},
      })
    });
  }
  changeLayout(e){
      var layoutId = parseInt(e.target.value);
      __GPYPost('setUIState',{currentOverlayLayout: layoutId});
      this.setState({overlaysIsLoaded:false, currentOverlayElement : {id:-1}},() => {
          this.setCurrentLayout(layoutId);
      });
  }
  setCurrentLayout(layoutId) {
     if(layoutId === -1) {
          this.setState({currentLayout:{id:-1}});
      }
      this.state.layouts.forEach((t) => {
           console.log(t,layoutId,t.id === layoutId);
           if(t.id === layoutId) {
             this.setState({currentLayout:t});
           }
      });
  	  if(this.state.components['__DISPLAY__']!== undefined) {
  		    this.state.components['__DISPLAY__'].getOverlays(layoutId);
  		}
  }


  /* ===========================================================================
  *  GAMES
  */
  onSelectGame(pk,reset) {
     pk = parseInt(pk,10);
     var g = undefined;
     this.state.games.Games.Game.forEach((t) => {
         if(t.id === pk) {
           g = t;
         }
     });
     if(g === undefined) {
         this.state.games.Games.GuestGame.forEach((t) => {
           if(t.id === pk) {
             g = t;
           }
         });
     }


     if(reset!==undefined) {
       reset();
     }

     Object.keys(this.state.components).forEach(key => {
         var c = this.state.components[key];
         if(c !== undefined && c['onDeactivate'] !== undefined){
           if(c['isActive']()) {
              c['onDeactivate']();
           }
         }
     });

     $('#gametype_'+this.state.NAME+'_scoreboard_games').collapse('hide');
     if(g !== undefined) {

       var teamMap = {};
       g.teams.Team.forEach((t) => {
           teamMap[t.vsRole] = t;
       });
       g.teamMap = teamMap;

       g.players.Player.forEach( (p) => {
         if(p.vsUiState === undefined || p.vsUiState === '') {
             p.vsUiState = '{"player":false, "substitue":false, "sortIndex" : 0 }';
         }
         p._config = JSON.parse(p.vsUiState);
       });

       g.players.Player.sort(_GPY.playerSorter);


       this.setState({currentGame: g,_freeText: _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_freetext_welcome')+"\n"+g.gameName},()=>{
         if(this.state.components['gamelog'] !== undefined && this.state.components['gamelog'] !== undefined){
           this.state.components['gamelog'].init();
         }
       });

       if(g.gameData !== undefined && g.gameData.values !== undefined) {
         var ds = JSON.parse(JSON.stringify(this.state.defaultDataStore));
         for (var key in g.gameData.values) {

            if (g.gameData.values.hasOwnProperty(key)) {
                console.log("___DS",key,g.gameData.values[key]);
                ds = JSON.parse(g.gameData.values[key]);
            }
        }
        this.setState({dataStore:ds});
       }
       __GPYPost('setUIState',{selectedGamePk: g.id});
     }
   }


   getGames(obj) {
       if(obj === undefined) {
         obj = {};
       }
       __GPYPost('getGames',obj,(res) => {
          res.Games.Game.forEach((t) => {
            if(t.teams.Team === undefined || t.teams.Team.length === 0) {
              t.teams.Team = [{id:-1,vsRole:"HOME_TEAM"},{id:-1,vsRole:"GUEST_TEAM"}];
            }
          });
          this.setState({
           gamesIsLoaded: true,
           games: res,
          });
         if(_GPY.uiStates.selectedGamePk !== undefined) {
           this.onSelectGame( _GPY.uiStates.selectedGamePk );
         } else {
           $('#gametype_'+this.state.NAME+'_scoreboard_games').collapse('show');
         }
       },(err)=>{
       });
   }

   getHomeOrGuestPlayer() {
       if(this.state.selectedPlayers['HOME_TEAM_PLAYER']!== undefined && this.state.selectedPlayers['GUEST_TEAM_PLAYER'] === undefined) {
         return this.state.selectedPlayers['HOME_TEAM_PLAYER'];
       }
       if(this.state.selectedPlayers['GUEST_TEAM_PLAYER']!== undefined && this.state.selectedPlayers['HOME_TEAM_PLAYER'] === undefined) {
         return this.state.selectedPlayers['GUEST_TEAM_PLAYER'];
       }
       return {id:-1};
    }

    getHomeOrGuestSubstitutionPlayer(){
        if(this.state.selectedPlayers['HOME_TEAM_SUBSTITUE']!== undefined && this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'] === undefined) {
        return this.state.selectedPlayers['HOME_TEAM_SUBSTITUE'];
       }
      if(this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE']!== undefined && this.state.selectedPlayers['HOME_TEAM_SUBSTITUE'] === undefined) {
        return this.state.selectedPlayers['GUEST_TEAM_SUBSTITUE'];
      }
      return {id:-1};
    }

    playerCountByRole(roles) {
        var res = 0;
        var role = roles.split(',');
        for( var i=0;i<role.length;i++) {
          if( this.state.selectedPlayers[role[i]] !== undefined) {
            res++;
          }
        }
        return res;
    }

    getTeamByCoach(p) {
      if(p.vsRole === 'HOME_TEAM_COACH') {
         return this.state.currentGame.teamMap.HOME_TEAM;
      } else {
        return this.state.currentGame.teamMap.GUEST_TEAM;
      }
    }

  	 getTeamByPlayer(p) {
  		 if(p.vsRole === 'HOME_TEAM_PLAYER' || p.vsRole === 'HOME_TEAM_SUBSTITUE') {
  			 	return this.state.currentGame.teamMap.HOME_TEAM;
  		 } else {
  			 return this.state.currentGame.teamMap.GUEST_TEAM;
  		 }
  	 }

      unselectPlayertLists() {

        if(this.state.components.SoccerFootball_teamlist_home_player!==undefined) this.state.components.SoccerFootball_teamlist_home_player.forceUnselectPlayer();
  			if(this.state.components.SoccerFootball_teamlist_guest_player!==undefined) this.state.components.SoccerFootball_teamlist_guest_player.forceUnselectPlayer();
  			if(this.state.components.SoccerFootball_teamlist_home_substitue!==undefined) this.state.components.SoccerFootball_teamlist_home_substitue.forceUnselectPlayer();
  			if(this.state.components.SoccerFootball_teamlist_guest_substitue!==undefined) this.state.components.SoccerFootball_teamlist_guest_substitue.forceUnselectPlayer();
      }
  		refreshPlayerLists() {
  			if(this.state.components.SoccerFootball_teamlist_home_player!==undefined) this.state.components.SoccerFootball_teamlist_home_player.refresh();
  			if(this.state.components.SoccerFootball_teamlist_guest_player!==undefined) this.state.components.SoccerFootball_teamlist_guest_player.refresh();
  			if(this.state.components.SoccerFootball_teamlist_home_substitue!==undefined) this.state.components.SoccerFootball_teamlist_home_substitue.refresh();
  			if(this.state.components.SoccerFootball_teamlist_guest_substitue!==undefined) this.state.components.SoccerFootball_teamlist_guest_substitue.refresh();
  		}

  		selectPlayerById(id) {
  				if(this.state.components.SoccerFootball_teamlist_home_player!==undefined) this.state.components.SoccerFootball_teamlist_home_player.selectPlayerById(id);
  				if(this.state.components.SoccerFootball_teamlist_guest_player!==undefined) this.state.components.SoccerFootball_teamlist_guest_player.selectPlayerById(id);
  				if(this.state.components.SoccerFootball_teamlist_home_substitue!==undefined) this.state.components.SoccerFootball_teamlist_home_substitue.selectPlayerById(id);
  				if(this.state.components.SoccerFootball_teamlist_guest_substitue!==undefined) this.state.components.SoccerFootball_teamlist_guest_substitue.selectPlayerById(id);
  		}

      onSelectPlayer(player) {
        var s = this.state;
        s.selectedPlayers[player.vsRole] = player;
        this.setState({selectedPlayers : s.selectedPlayers});
        this.doChangeValue(player,undefined,"onSelectPlayer");
        console.log(s);
      }

      onDeselectPlayer(role,player) {
        if(player!==undefined) {
          this.doChangeValue(player,undefined,"onDeselectPlayer");
        }
        var state = this.state;
        delete state.selectedPlayers[role];
        this.setState(state);
      }

      registerComponent(name,c) {
  			var comps = this.state.components;
        comps[name] = c;
        this.setState({components:comps});
  		}

      onPlayTime(stateName,method){
        var c = this.state.components[stateName];
        if(c !== undefined && c[method] !== undefined) {
          c[method](()=>{
            this.forceUpdate();
          });
        }
      }

      setGameTime(stateName,s) {
         this.doChangeValue({
           offset:s,
         },stateName);
      }

      setTimeTo(stateName,s) {
        if(this.state.components[stateName] !== undefined){
          this.state.components[stateName].setTimeTo(s);
        }
      }

      startTimeAt(stateName,s) {
        if(this.state.components[stateName] !== undefined){
          this.state.components[stateName].startAt(s);
        }
      }

      storeOnChangeFormData(name,e) {
        if(e!==undefined) {
          		 var s = {};
  			       s[name] = e.target.value;
  			       this.setState(s);
        }
  		}

      doCall(name,obj,k) {
        if(k !== undefined){
          var c = this.state.components[k];
          if(c !== undefined && c[name] !== undefined){
            c[name](obj);
          }
          return;
        }
        Object.keys(this.state.components).forEach(key => {
            var c = this.state.components[key];
            if(c !== undefined && c[name] !== undefined){
              c[name](obj);
            }
        });
      }

      doChangeValue(obj,k,method) {
  			if(k !== undefined) {
  				var c = this.state.components[k];
  				if(method!== undefined  && c[method] !== undefined) {
  					c[method](obj);
  				} else if(c !== undefined && c.onChangeValue !== undefined){
  						c.onChangeValue(obj);
  				}
  				return;
  		 	}

  			Object.keys(this.state.components).forEach(key => {
  					var c = this.state.components[key];
  					if(method!== undefined  && c[method] !== undefined) {
  						c[method](obj);
  					} else if(c !== undefined && c.onChangeValue !== undefined){
  							c.onChangeValue(obj);
  					}
  			});
  		}

      reset() {
        Object.keys(this.state.components).forEach(key => {
            var c = this.state.components[key];
            if(c !== undefined && c['onDeactivate'] !== undefined){
              if(c['isActive']()) {
                 c['onDeactivate']();
              }
            }
        });
        if(this.state.components['gamelog'] !== undefined && this.state.components['gamelog'] !== undefined){
          this.state.components['gamelog'].init();
        }
      }

     getGamesStates() {
       __GPYPost('getGameState',{gameState:this.props.stateName},(res) => {
         var allStates = res.GameState.values;

         Object.keys(allStates).forEach(key => {
           if(allStates[key].startsWith('{')){
             allStates[key] = JSON.parse(allStates[key]);
           }
         });
         allStates["defaultValuesLoaded"] = true;
         this.setState( allStates );
       });
     }

     getAdvertisements() {
       __GPYPost('getAdvertisements',{usageType:"ADVERTISING"},(res)=>{
         this.setState({
           advertisementsIsLoaded: true,
           advertisements: res,
         });
       },(err)=>{
         this.setState({
           advertisementsIsLoaded: false,
         });
       });
     }

    getDefaultValues(clazz) {
      __GPYPost('getGameState',{gameState:clazz},(res) =>  {
        this.setState({defVal : res.GameState.values});
      });
    }

    onData(key,data) {
      // console.log("onData GameScoreBoard >> ",key,data);
      var tmp = this.state.components[key];
        /*
        if(tmp === undefined && key.endsWith("_timeout")) {
          tmp = this.state.components[key.replace("_timeout","")];
        }*/
      if(tmp !== undefined && tmp.onData !== undefined) {
        tmp.onData(key,data);
      }
    }
}

export default OBSOLATE_GameScoreBoard;
